<template>
  <hr class="app-separator-line" :style="style" />
</template>

<script>
export default {
  name: 'AppSeparatorLine',
  props: {
    backgroundColor: {
      type: String,
      default: undefined,
    },
    maxWidth: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    style() {
      return {
        '--app-separator-line-bg-color': this.backgroundColor,
        '--app-separator-line-max-width': this.maxWidth,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-separator-line {
  width: 100%;
  height: 1px;
  border: none;
  margin: 0 auto;
  max-width: var(--app-separator-line-max-width, 'none');
  background-color: var(--app-separator-line-bg-color, vars.$c-gray-e0);
}
</style>
